import React, { Component } from 'react';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';

import { Link } from 'react-router-dom';
import Icon from 'components/Icon';

const StyledAppTrail = styled.div`
    nav {
        color: ${props => props.theme.color.halfWhite};
        padding-left: 15px;
        padding-right: 15px;
        position: relative;
        &.nav-customer {
            background: #444;
        }
        a {
            color: ${props => props.theme.color.white};
            display: inline-block;
            padding: 8px;
        }

        // bs override...
        .breadcrumb-item + .breadcrumb-item::before {
            color: ${props => props.theme.color.halfWhite};
            float: none;
        }
    }
    ol {
        background: transparent;
        margin: 0;
        padding: 0;
        .marker {
            border-right: 1px solid ${props => props.theme.color.halfWhite};
            margin-right: 5px;
            padding-right: 1.2rem;
            padding-left: 0.25rem;
            padding-top: 8px;
        }
    }
`;

class AppTrail extends Component {
    render() {
        const { apps, appLocations, appTrail, currentApp } = this.props;
        const trail = appTrail.filter(key => key !== currentApp && key !== 'dashboard');

        return (
            <StyledAppTrail className='apptrail d-print-none'>
                {trail.length > 0 && (
                    <nav aria-label='recent apps' className='bg-primary'>
                        <Helmet bodyAttributes={{ class: currentApp + ' app-trail' }} />
                        <ol className='breadcrumb'>
                            <li className='marker'>
                                <Icon name='history' />
                            </li>
                            {trail.map((key, i) => {
                                const app = apps[key];
                                let { path, title } = appLocations[key] || {};

                                // clean up title or use app label for default
                                // i.e. 'Portal | Health Employers | Archimedes Smith' -> 'Archimedes Smith'
                                title = title
                                    ? title.split('|').reverse()[0]
                                    : app.label;

                                // default to app home if no path
                                path = path || app.path;

                                return (
                                    <li key={i} className='breadcrumb-item app-item'>
                                        <Link
                                            to={path}
                                            className='text-decoration-none'
                                        >
                                            <Icon name={app.icon} /> {title}
                                        </Link>
                                    </li>
                                );
                            })}
                        </ol>
                    </nav>
                )}
            </StyledAppTrail>
        );
    }
}

export const BreadcrumbTrail = ({apps, appLocations, appTrail, currentApp, breadcrumbs, rightItems=null}) => {

    const icon = apps["health_employers"].icon

    return (
        <StyledAppTrail className='apptrail d-print-none'>
            {(breadcrumbs.employer || breadcrumbs.app) && (
                <nav aria-label='recent apps' className='bg-primary d-flex'>
                    <Helmet bodyAttributes={{ class: currentApp + ' app-trail' }} />
                    <ol className='breadcrumb'>
                        <li className='marker'>
                            <Icon name='history' />
                        </li>
                            {breadcrumbs.employer && (
                                <li className='breadcrumb-item app-item'>
                                <Link
                                    to={breadcrumbs.employer.path}
                                    className='text-decoration-none'
                                >
                                    <Icon name={icon} /> {breadcrumbs.employer.title}
                                </Link>
                            </li>)}
                            {breadcrumbs.app && (
                                <li className='breadcrumb-item app-item'>
                                <Link
                                    to={(breadcrumbs.employer?.path || '') + '/' + breadcrumbs.app.path}
                                    className='text-decoration-none'
                                >

                                    <Icon name={apps[breadcrumbs.app.title].icon}/> {apps[breadcrumbs.app.title].label}
                                </Link></li>
                                )}
                    </ol>
                    {rightItems}
                </nav>
            )}
        </StyledAppTrail>
    );
}


export default AppTrail;
